import { jsx } from "react/jsx-runtime";
import { createSvgIcon } from "@mui/material";
const ImportantIcon = createSvgIcon(
  /* @__PURE__ */ jsx("svg", { width: "22", height: "18", viewBox: "0 0 22 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx(
    "path",
    {
      d: "M21.2394 15.451L12.4424 0.816C12.1354 0.305 11.5964 0 11.0004 0C10.4044 0 9.86537 0.305 9.55937 0.815L0.761373 15.451C0.449373 15.97 0.441373 16.619 0.739373 17.146C1.03637 17.673 1.59737 18 2.20337 18H19.7984C20.4034 18 20.9654 17.673 21.2624 17.146C21.5604 16.619 21.5514 15.97 21.2394 15.451ZM12.0004 14C12.0004 14.5523 11.5527 15 11.0004 15C10.4481 15 10.0004 14.5523 10.0004 14C10.0004 13.4477 10.4481 13 11.0004 13C11.5527 13 12.0004 13.4477 12.0004 14ZM12.0004 10C12.0004 10.5523 11.5527 11 11.0004 11C10.4481 11 10.0004 10.5523 10.0004 10V7C10.0004 6.44772 10.4481 6 11.0004 6C11.5527 6 12.0004 6.44772 12.0004 7V10Z",
      fill: "#D63245"
    }
  ) }),
  "Important"
);
export {
  ImportantIcon as default
};
